<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <section class="page_404">
      <div class="row">
        <div class="col-sm-12 ">
          <div class="col-sm-offset-1  text-center">
            <div class="four_zero_four_bg">
              <h1 class="text-center">
                {{ ($route.query && $route.query['status'] == 0) ? 'Vô hiệu hóa' : 'Khai báo hệ thống' }}</h1>
            </div>
            <div class="contant_box_404">
              <h4 class="h4" v-if="$route.query && $route.query['status'] == 0">Tài khoản của bạn đã bị vô hiệu hóa. Xin
                vui lòng liên hệ admin để được hỗ trợ. Xin cảm ơn!</h4>
              <h4 class="h4" v-else>Tài khoản của bạn đang chờ khai báo hệ thống. Xin vui lòng liên hệ admin để được hỗ
                trợ. Xin cảm ơn!</h4>
              <!--              <p>Tài khoản của bạn đã bị vô hiệu hóa. Xin vui lòng liên hệ admin để được hỗ trợ. Xin cảm ơn.</p>-->
              <button @click="submitReload()" class="btn btn-action-primary btn-primary">Thử lại <i
                  class="fa fa-refresh"></i></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </CContainer>
</template>

<script>
export default {
  name: 'PageNotifySSO',
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    submitReload() {
        window.location.href = `https://sso.backan.gov.vn/logout?backtologin=${process.env.SERVICE_SSO}/login.html`;
    }
  }
}
</script>
<style scoped>
.page_404 {
  padding: 40px 0;
  background: #fff;
  width: 100%;
}

.page_404 img {
  width: 100%;
}

.four_zero_four_bg {
  background-image: url('/static/img/error.gif');
  height: 400px;
  background-position: center;
  background-repeat: no-repeat;
}


.four_zero_four_bg h1 {
  font-size: 80px;
}

.four_zero_four_bg h3 {
  font-size: 80px;
}

.link_404 {
  color: #fff !important;
  padding: 10px 20px;
  background: #39ac31;
  margin: 20px 0;
  display: inline-block;
}

.contant_box_404 {
  margin-top: -50px;
}
</style>
